
const PdfViewer = ({ pdfUrl }) => {



    return (
        <div className='pdf_main' style={{ width: '100%', height: "100%" }}>

            <iframe
                src={pdfUrl}
                style={{ width: "100%", height: "100vh" }}
                // className="w-full h-full"
                frameBorder="0"
                title="PDF Viewer"
            ></iframe>

        </div>
    );
};

export default PdfViewer;
